import { render } from "./keMaMemberPayModel.vue?vue&type=template&id=83c884a0"
import script from "./keMaMemberPayModel.vue?vue&type=script&lang=js"
export * from "./keMaMemberPayModel.vue?vue&type=script&lang=js"

import "./keMaMemberPayModel.vue?vue&type=style&index=0&id=83c884a0&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__